import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {BaseComponent, WmsDialogBodyComponent, WmsDialogComponent, WmsDialogHeaderComponent, WmsDialogFooterComponent, WmsToggleComponent } from '@wms/components';
import { FormsModule } from '@angular/forms';
import { ApisService,WebserviceService,ProjectService,OauthService, NotificationService} from "@wms/services";
import {ImportApiComponent} from "@wms/app/workspace/api-workspace/import-api/import-api.component";
import { DialogService } from '@wms/app/services/dialog/dialog.service';
import { OauthProviderComponent } from '../oauth-provider/oauth-provider.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import {replace, VersionManagerPipe} from "@wms/core";
@Component({
  selector: 'wms-api-settings',
  standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        WmsToggleComponent,
        WmsDialogComponent,
        WmsDialogBodyComponent,
        WmsDialogHeaderComponent,
        WmsDialogFooterComponent,
        ImportApiComponent,
        OauthProviderComponent,
        TooltipModule,
        VersionManagerPipe
    ],
  templateUrl: './api-settings.component.html',
  styleUrls: ['./api-settings.component.less']
})
export class ApiSettingsComponent extends BaseComponent implements OnInit, OnDestroy {

  public isMockEnabled: boolean;
  showSecurityConfig: boolean = false;
  showSecurityMsg: boolean;
  apiMockEnabledSubscription: any;
  notificationService: NotificationService;

  onClickSecurityConfiguration(): void {
    this.showSecurityConfig = !this.showSecurityConfig;
  }

  updateMockServerStatus(): void {
    if (this.isMockEnabled) {
      this.dialogService.open("MockServerConfirmDialog");
    }
    else {
      this.openMockServerProgressDialog();
    }
  }

  closeCreateMockServerCard(): void{
    window.localStorage.setItem('mock-server-intro-done','true');
    this.apiService.mockServerIntroDone = true;
  }

  closeDialogWithId(id: string): void {
    this.dialogService.close(id)
  }

  openMockServerProgressDialog(): void{
    this.dialogService.open('MockServerInProgressDialog');
    this.apiService.triggerMockServer();
  }

  openOauthProviderConfigDialog(params: any): void{
    this.dialogService.open('wm-oAuth-dialog');
    (this.oAuthService.loadConfiguredProviders() as Promise<any>).then((response: any) => {
      this.apiService._apiConfiguredProviderSubject.next(response);
    });
  }

  saveSecurityConfiguration(): void{
    const useProxy = this.apiService.config.useProxy ? this.apiService.RUNTIME_CALL_MODE.PROXY : this.apiService.RUNTIME_CALL_MODE.DIRECT;
    const connectionParams = {
      'data' : {
        'host': this.apiService.config.host,
        'basePath': this.apiService.config.basePath,
        'securityConfigs': this.apiService.config.securityConfigs,
        'proxySettings': {web: useProxy, mobile: useProxy, withCredentials: this.apiService.config.withCredentials}
      },
      'urlParams' : {'projectId' : this.projectService.getProjectId(),'serviceId' : this.apiService.activeApi.serviceId}
    };
    (this.webService.setOpenAPISecurityConfiguration(connectionParams) as Promise<any>).then((resp: any) => {
      this.projectService.getAppRunURL();
      this.showSecurityConfig = false;
     this.notificationService.show('success', this.locale.MESSAGE_SUCCESS_TITLE, replace(this.locale.MESSAGE_API_SETTINGS_SAVE_SUCCESS, [this.apiService.activeApi.serviceId]));
    });
  }

  constructor(public apiService: ApisService, private dialogService: DialogService, private webService: WebserviceService, private oAuthService: OauthService) {
    super();
    this.dialogService = inject(DialogService);
    this.notificationService = inject(NotificationService);
    if (window.localStorage.getItem('mock-server-intro-done') == 'true') {
      this.apiService.mockServerIntroDone = true;
    }
  }

  useProxyToggle(event: any): void{
    if(event == false){
      this.apiService.config.useProxy = false;
    }
    else {
      this.apiService.config.useProxy = true;
   }
  }

  useCredentialsToggle(event: any): void{
    if(event == false){
      this.apiService.config.withCredentials = false;
    }
    else {
      this.apiService.config.withCredentials = true;
    }
  }

  onCancel(event: any){
    this.dialogService.close("MockServerConfirmDialog");
  }

  onOk(event: any){
    let params = {
      enableMock : false,
      projectID  : this.projectService.getProjectId(),
      serviceID  : this.apiService.activeApi.serviceId,
      showSpinner : false
    }
    this.dialogService.close("MockServerConfirmDialog");
    this.apiService.stopMockServer(params);
  }

  ngOnInit(): void {
    this.isMockEnabled = this.apiService.currentService.isMockEnabled;
    this.showSecurityMsg = this.apiService.showSecurityMsg;
    this.apiMockEnabledSubscription = this.apiService._apiMockEnabledSubject.subscribe((response: any) => {
      this.isMockEnabled = response;
      this.apiService.currentService.isMockEnabled = response;
    });
  }
  override ngOnDestroy() {
    super.ngOnDestroy();
    if (this.apiMockEnabledSubscription) {
      this.apiMockEnabledSubscription.unsubscribe();
    }
  }
}
